import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-info-outline',
  templateUrl: './icon-info-outline.component.html',
  styleUrls: ['./icon-info-outline.component.scss'],
})
export class IconInfoOutlineComponent {
  @Input() color = '#064e3b';
  @Input() width = '12';
  @Input() height = '12';
}
